export enum InstitutionType {
  LOCAL = 'LOCAL',
  DIRECTORY = 'DIRECTORY'
}
